import { useState } from "react";
import { CONTENT_HEADING } from "../../constants";
import ReactPlayer from "react-player/youtube";
import Content from "../global/Content";
import { useNavigate,Link } from "react-router-dom";
import SubmitArticleModal from "../Modal/SubmitArticleModal";
import { isMobile } from 'react-device-detect';
import MobileModalAlert from "../Modal/MobileModalAlert";
import MobileModalReg from "../Modal/MobileMobleReg";

const RegistrationProcess = () => {
  const [uploadArticle, setUploadArticle] = useState(false);
  const [mobileAlert, setMobileAlert] = useState(false);
  const [mobileAlertReg, setMobileAlertReg] = useState(false);
  const navigate = useNavigate();
	const handleRedirect = (e, path = "/registration") => {
		e.preventDefault();
		window.scroll({ top: 0, behavior: "smooth" });
		navigate(path);
	  };
  const token = localStorage.getItem("usertoken");
  
  return (
    <>
      <div className="mt-5">
        <Content title="Peer Review">
          <p className="pera-text tagp">
            Mega Journal and Society Journal submissions undergo Pre-Publication Double-Anonymous Peer Review. Our systems automatically hide relevant author details.
          </p>
          <p className="pera-text tagp">
            Articles published in Mega Journals may additionally receive Post-Publication Open Review. Society Journals decide whether to enable this feature.
          </p>
          <p className="pera-text tagp mb-5">
            Read more about our <Link to="/peer-review-models" target="_blank" className="underline blackbold" style={{color: "#366c91"}}>Peer Review Models</Link>.
          </p>
        </Content>
      </div>

      {/* 
      <Content title={CONTENT_HEADING.HOW_TO_REGISTER}>
        <div className="center-image videoPageChk">
          <iframe width="560" height="315" className="w-100" src="https://www.youtube.com/embed/w68GPd_pliU?si=GqZAcV60uoc7pfp7" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay=1; loop=1; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" autoplay="true" loop="true" allowfullscreen="true"></iframe>
        </div>
      </Content>

      <h2 className='large-title center-title tagh2 mt-3'>Article Submission Process on <br /> Aakashganga Platform</h2>
        <div className="center-image mb-3 videoPageChk">
          <iframe width="560" height="315" className="w-100" src="https://www.youtube.com/embed/IaPrg-5O-Ks?si=SOkK0XUcwvFDM5hL" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" autoplay="true" loop="true" allowfullscreen="true"></iframe>
        </div>

        <p
          className="pera-text customregprocess tagp"
        >
          Ready to submit an article but don’t have an account?
        </p>

        <div className="register-button mt-small">
          <button onClick={(e) =>isMobile ? setMobileAlertReg(true): handleRedirect(e, "/registration")}>Register now</button>
        </div>

        <p className="pera-text tagp">
          From your account, please click the{" "}
          {!token && (
            <Link
              to="/login"
              onClick={(e) => {
                if (isMobile) {
                  e.preventDefault();
                  setMobileAlert(true);
                }
              }}
              className="underline blackbold"
            >
              Publish Your Article
            </Link>
          )}
          {token && (
            <button
              type="button"
              onClick={() => {
                isMobile ? setMobileAlert(true) : setUploadArticle(true);
              }}
              className="underline blackbold"
              style={{ background: "none", border: "none", padding: 0, font: "inherit", cursor: "pointer" }}
            >
              Publish Your Article
            </button>
          )}{" "}
          button. This takes you to the submission details screen. We require
          all the fields filled so that we know exactly what the article is
          about.
        </p>

        <p className="pera-text tagp">
          We request that you click on all the ‘I’ icons to read the
          requirements of each section before providing your details. We have
          tried to provide clear explanations and steps at every level of the
          submission process. In case, you have a question that is not answered,
          please write to us directly at
          <Link
            to="mailto:contactus@vilramshilaedu.in"
            className="underline blackbold"
          >
            {" "}
            contactus@vikramshilaedu.in
          </Link>
        </p>
      */}
      <SubmitArticleModal uploadArticle={uploadArticle} setUploadArticle={setUploadArticle} />
      <MobileModalAlert mobileAlert={mobileAlert} setMobileAlert={setMobileAlert} />
      <MobileModalReg mobileAlertReg={mobileAlertReg}
    setMobileAlertReg={setMobileAlertReg} />
    </>
  );
};

export default RegistrationProcess;
